module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pb-5",
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.disableEdit ? 'Edit' : 'Create') + " COGS Estimation")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "0px 50px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [(!_vm.payout.id) ? _c('v-combobox', {
    attrs: {
      "items": _vm.campaigns,
      "search-input": _vm.search,
      "hide-details": "auto",
      "item-text": "displayName",
      "error-messages": _vm.selectedCampaignErrors,
      "label": "IO or Campaign",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "blur": function($event) {
        return _vm.$v.payout.campaign.$touch()
      },
      "change": function($event) {
        return _vm.changeCampaign()
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                        No results matching \"\n                        "), _c('strong', [_vm._v(_vm._s(_vm.search))]), _vm._v("\". Press "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                      ")])], 1)], 1)]
      },
      proxy: true
    }], null, false, 1677632798),
    model: {
      value: (_vm.payout.campaign),
      callback: function($$v) {
        _vm.$set(_vm.payout, "campaign", $$v)
      },
      expression: "payout.campaign"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.payout.id && _vm.payout.campaign) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Campaign : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "body-2 mb-0"
  }, [_vm._v(_vm._s(_vm.payout.campaign.ioNumbers) + " - " + _vm._s(_vm.payout.campaign.name))])])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Incurred Date (DD/MM/YYYY) : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "disabled": _vm.disableEdit
    },
    on: {
      "blur": function($event) {
        return _vm.$v.payout.live_date.$touch()
      },
      "input": _vm.changeLiveDate,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeLiveDate.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.payout.live_date),
      callback: function($$v) {
        _vm.$set(_vm.payout, "live_date", $$v)
      },
      expression: "payout.live_date"
    }
  }, _vm.on)), _vm._v(" "), (_vm.isInvalidLiveDate) ? _c('span', {
    staticClass: "custom-danger ma-0 pt-1"
  }, [_vm._v("Invalid Incurred Date")]) : _vm._e(), _vm._v(" "), (!_vm.isInvalidLiveDate && !_vm.payout.live_date) ? _c('span', {
    staticClass: "custom-danger ma-0 pt-1"
  }, [_vm._v("This field is required")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Creator Handle : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [(!_vm.disableEdit) ? _c('v-combobox', {
    attrs: {
      "items": _vm.influencers,
      "item-text": "handle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.handle,
            "instagramHandle": item.handle,
            "youtubeHandle": item.handle,
            "facebookHandle": item.handle,
            "xiaohongshuHandle": item.handle
          }
        })]
      }
    }], null, false, 4074452561),
    model: {
      value: (_vm.payout.handle),
      callback: function($$v) {
        _vm.$set(_vm.payout, "handle", $$v)
      },
      expression: "payout.handle"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.disableEdit && _vm.payout.handle) ? _c('p', {
    staticClass: "subtitle-1 mb-0"
  }, [_vm._v(_vm._s(_vm.payout.handle.handle))]) : _vm._e(), _vm._v(" "), (_vm.disableEdit && !_vm.payout.handle) ? _c('p', {
    staticClass: "subtitle-1 mb-0"
  }, [_vm._v("-")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Type : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.estimationTypes,
      "label": "Type",
      "error-messages": _vm.estimationTypeErrors,
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "blur": function($event) {
        return _vm.$v.payout.estimationType.$touch()
      }
    },
    model: {
      value: (_vm.payout.estimationType),
      callback: function($$v) {
        _vm.$set(_vm.payout, "estimationType", $$v)
      },
      expression: "payout.estimationType"
    }
  }), _vm._v(" "), (_vm.payout.estimationType === 'Others') ? _c('v-text-field', {
    staticClass: "mt-2",
    attrs: {
      "placeholder": "Custom",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.payout.customType),
      callback: function($$v) {
        _vm.$set(_vm.payout, "customType", $$v)
      },
      expression: "payout.customType"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Amount : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "disabled": _vm.disableEdit,
      "error-messages": _vm.amountErrors,
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": "",
      "hide-details": "auto"
    },
    on: {
      "blur": function($event) {
        return _vm.$v.payout.amount.$touch()
      }
    },
    model: {
      value: (_vm.payout.amount),
      callback: function($$v) {
        _vm.$set(_vm.payout, "amount", $$v)
      },
      expression: "payout.amount"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Remarks : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "hide-details": "",
      "disabled": _vm.disableEdit,
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.payout.remarks),
      callback: function($$v) {
        _vm.$set(_vm.payout, "remarks", $$v)
      },
      expression: "payout.remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('custom-file-upload', {
    attrs: {
      "title": "Upload Invoices",
      "refresh": _vm.fileUploadRefresh,
      "multiple": true
    },
    on: {
      "setMedias": _vm.updateInvoices
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.disableSavePayout,
      "text": ""
    },
    on: {
      "click": _vm.savePayout
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-650502ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/CogsEstimate/CreateCogsEstimateModal.vue
// module id = 2162
// module chunks = 0